// extracted by mini-css-extract-plugin
export default {"navbar":"Header_navbar__0WeCu","link":"Header_link__47f39","scrolled":"Header_scrolled__PLF6O","active":"Header_active__x0s1D"};